export function FolderIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 160 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0 117V3C0 1.34315 1.34315 0 3 0H51.5799C53.6083 0 55.4993 1.02478 56.6067 2.72412L63.8427 13.8276C64.9501 15.5269 66.8412 16.5517 68.8695 16.5517H157C158.657 16.5517 160 17.8949 160 19.5517V117C160 118.657 158.657 120 157 120H3C1.34315 120 0 118.657 0 117Z"
        fill="#CAD6D8"
      />
    </svg>
  );
}
